import { useEffect, useState } from "react";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { InputMoney } from "../../../../../theme/Input/InputMoney";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _LoanLine } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { MASK_MONEY } from "../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../theme/Component/Modal";
import { MultiInputMoney } from "../../../../../theme/Input/MulitInputMoney";
import { LoanLineEditor } from "../../../../../admin/CreditPotfolio/LoanLine/LoanLineEditor";

interface Props {
    props: any;
    propsImp?: any;
    _pushProps?: Function;
}
export const CalculadoraCredito = ({ props, propsImp, _pushProps }: Props) => {

    const _loan = useDataBean(_LoanLine);
    const [loan, setLoan] = useState<any>({});
    const [tablaCuotas, setTablaCuotas] = useState<any>([]);
    const [bean, setBean] = useState<any>({
        A: 0,
        B: 0,
        C: 0,
        D: 0,
    });
    const [neto, setNeto] = useState<number>(0);
    const [cuota, setCuota] = useState<number>(0);
    const [prote, setProte] = useState<number>(47.2);

    useEffect(() => {
        if (propsImp) {
            let id = propsImp.IDLoanLine;
            if (id != loan.IDLoanLine) {
                _loan.instance.getLoanLine(id).then(
                    (resp: any) => {
                        if (resp) {
                            setLoan(resp);

                        }
                    }
                );
            }
        }
    }, [propsImp])

    // useEffect(() => {
    //     if (_pushProps && bean != props)
    //         _pushProps(bean);
    // }, [bean])



    // useEffect(() => {
    //     if (!props) return;

    //     const parsedProps = typeof props === 'string' ? JSON.parse(props) : props;

    //     setBean({
    //         A: Number(parsedProps.A) || 0, //total
    //         B: Number(parsedProps.B) || 0,  // adicional
    //         C: Number(parsedProps.C) || 0,  // descuentos
    //         D: Number(parsedProps.D) || 0,  // reintegro
    //         E: Number(parsedProps.E) || 0,  // Total descuanto 
    //         F: Number(parsedProps.E) || 0,  // Sueldo Neto
    //         G: Number(parsedProps.E) || 0,  // Capacidad
    //     });

    // }, [props]);
    useEffect(() => {
        if (!props) return;

        const parsedProps = typeof props === 'string' ? JSON.parse(props) : props;

        setBean((prev: any) => ({
            ...prev,
            A: Number(parsedProps.A) || 0,
            B: Number(parsedProps.B) || 0,
            C: Number(parsedProps.C) || 0,
            D: Number(parsedProps.D) || 0,
        }));

        setNeto(Number(parsedProps.Neto) || 0);
        setCuota(Number(parsedProps.Cuota) || 0);
        setProte(Number(parsedProps.Proteccion) || 47.2);
    }, [props]);



    const calcularCapacidad = () => {
        let copy: any = { ...bean };

        copy.E = 0;
        copy.F = 0;
        copy.G = 0;

        // Asegurarse de que todos los campos estén definidos como números válidos
        copy.A = Number((copy.A + "").replace(/[.,]/g, "")) || 0;
        copy.B = Number((copy.B + "").replace(/[.,]/g, "")) || 0;
        copy.C = Number((copy.C + "").replace(/[.,]/g, "")) || 0;
        copy.D = Number((copy.D + "").replace(/[.,]/g, "")) || 0;


        // Cálculos
        copy.E = copy.C - copy.D;
        copy.F = copy.A - copy.B - copy.E;
        copy.G = ((copy.A - copy.B) / 2) - copy.E;

        setBean(copy);
        calcularTabla(copy.G);
        _pushProps?.(copy);
    };

    const calcularCuota = (tasaInteresAnual: number, meses: number, monto: number) => {
        const tasaMensual = tasaInteresAnual / 100 / 12;
        const numeroCuotas = meses;

        if (tasaMensual === 0) {
            return monto / numeroCuotas;
        }

        const cuota =
            (monto * tasaMensual) /
            (1 - Math.pow(1 + tasaMensual, -numeroCuotas));

        return cuota;
    }
    type TablaOpcion = {
        plazoCredito: number;
        cuota: number;
        monto: number;
        montoRedondeado: number;
        esMejorOpcion: boolean;
    };

    const calcularTabla = (capacidad: number) => {
        const maxAmount = loan.MaximumLoanAmount;
        const minAmount = loan.MinimumLoanAmount;
        const percentInterest = loan.CurrentPercentInterest; // Ej: 12 (% anual)
        const quotaRange = loan.QuotaRange ? JSON.parse(`[${loan.QuotaRange}]`) : [1]; // en meses
        const redondeoBase = 1_000_000;

        const tasaMensual = percentInterest / 100 / 12;
        const tablaOpciones: TablaOpcion[] = [];

        quotaRange.forEach((plazo) => {
            let monto = 0;

            if (tasaMensual === 0) {
                monto = capacidad * plazo;
            } else {
                monto = capacidad * (1 - Math.pow(1 + tasaMensual, -plazo)) / tasaMensual;
            }

            monto = Math.max(minAmount, Math.min(monto, maxAmount));
            const montoRedondeado = Math.floor(monto / redondeoBase) * redondeoBase;

            let cuota = 0;
            if (tasaMensual === 0) {
                cuota = montoRedondeado / plazo;
            } else {
                cuota = (montoRedondeado * tasaMensual) / (1 - Math.pow(1 + tasaMensual, -plazo));
            }

            if (cuota <= capacidad) {
                tablaOpciones.push({
                    plazoCredito: plazo,
                    cuota: Math.round(cuota),
                    monto: Math.round(monto),
                    montoRedondeado,
                    esMejorOpcion: false, // lo marcamos después
                });
            }
        });

        // Buscar la mejor opción: mayor montoRedondeado, menor plazo en caso de empate
        if (tablaOpciones.length > 0) {
            let mejor = tablaOpciones[0];
            tablaOpciones.forEach(op => {
                if (
                    op.montoRedondeado > mejor.montoRedondeado ||
                    (op.montoRedondeado === mejor.montoRedondeado && op.plazoCredito < mejor.plazoCredito)
                ) {
                    mejor = op;
                }
            });

            tablaOpciones.forEach(op => {
                op.esMejorOpcion = op === mejor;
            });
        }

        console.table(tablaOpciones);
        setTablaCuotas(tablaOpciones);
    };

    return (
        <div className="row">
            {!propsImp?.IDLoanLine ?
                <div className="col-md-12">
                    <LoanLineEditor onChange={(e) => { setLoan(e) }} IDSelect={loan?.IDLoanLine} label="Linea de Crédito" />
                </div>
                : null
            }
            <div className="col-md-3">
                <div className="row">
                    <div className="col-md-12">
                        <InputMoney _label="Total Devengado" _value={bean.A} onChange={(e) => { setBean({ ...bean, A: e }) }} />
                    </div>
                    <div className="col-md-12">
                        <MultiInputMoney label="Adicionales" renderValue={bean.B} onChange={(e) => { setBean({ ...bean, B: e }) }} />
                    </div>
                    <div className="col-md-12">
                        <InputMoney _label="Descuentos" _value={bean.C} onChange={(e) => { setBean({ ...bean, C: e }) }} />
                    </div>
                    <div className="col-md-12">
                        {/* <InputMoney _label="Reintegro" _value={bean.D} onChange={(e) => { setBean({ ...bean, D: e }) }} /> */}
                        <MultiInputMoney label="Reintegro" renderValue={bean.D} onChange={(e) => { setBean({ ...bean, D: e }) }} />
                    </div>

                </div>

            </div>
            <div className="col-md-3">
                <div className="row">
                    <div className="col-md-12">
                        <InputMoney _label="Total Descuento" _value={bean.E} onChange={(e) => { }} readonly />
                    </div>
                    <div className="col-md-12">
                        <InputMoney _label="Sueldo Neto" _value={bean.F} onChange={(e) => { }} readonly />
                    </div>
                    <div className="col-md-12">
                        <InputMoney _label="Capacidad" _value={bean.G} onChange={(e) => { }} readonly />
                    </div>
                    <div className="col-md-12 mt-4">
                        <BasicButton icon="" eventClick={calcularCapacidad}>Calcular</BasicButton>
                    </div>
                </div>
            </div>
            <div className="col-md-6">
                {!propsImp?.IDLoanLine ? null : <h6><strong>Linea</strong> {loan.Name}  </h6>}
                <table className="table table-nowrap mb-0 tableCapacidad">
                    <thead>
                        <tr >
                            <th scope="col">Plazo</th>
                            <th scope="col">Cuota</th>
                            <th scope="col">Monto</th>
                            <th scope="col">Monto Redondeado</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tablaCuotas.map((row, _index) => {
                            return (
                                <tr key={_index} className={row.esMejorOpcion ? 'text-success' : ''}>
                                    <td>{row.plazoCredito}</td>
                                    <td dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(row.cuota, MASK_MONEY) }}></td>
                                    <td dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(row.monto, MASK_MONEY) }}></td>
                                    <td dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(row.montoRedondeado, MASK_MONEY) }}></td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>

        </div>
    )
}